<template>
  <section class="batteries">
    <div class="miles-estimated">
      <h2>{{txt.range.batteries.title}}</h2>
      <p class="speed">{{title}}&nbsp;{{txt.common.unit}}</p>
    </div>
 
  </section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
 name: "range",
  props: {
    title: Number,
    
  },

  data() {
    return {
      lengthArray: 1,
      lightboxVisible: false,
      lightBoxCopy: Object,
    };
  },
  components: {
    Lightbox
  },
  computed: {
    ...mapState({
      txt: state => state.txt,
      range: state => state.range
    })
  },
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    },
    lengthBatteryArray() {
      return Object.keys(this.txt.range.batteries.list).length;
    },
    getBatterySvg(index) {
      return index < 1 ? true : false;
    }
  }
};
</script>